import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Loader from '../../layouts/loader';
import apiService from '../../../services/apiService';

const CaseStudieDetail = () => {
    const [CaseStudieDetails, setCaseStudieDetails] = useState([]);
    const [loader, setLoader] = useState(false);
    const { id } = useParams();

    useEffect(() => {
        requestAnimationFrame(() => {
            window.scrollTo(0, 0);
        });
        if (id) {
            fetchCaseStudyDetails(id);
        }
    }, [id]);

    const fetchCaseStudyDetails = (id) => {
        setLoader(true);
        const token = apiService.getAuthToken();
        apiService.get(`get-case-studies-details/${id}`, token).then(
            (response) => {
                setCaseStudieDetails(response.data);
                console.log("Case Study Details:", response.data);
                setLoader(false);
            },
            (error) => {
                console.error("Error fetching data", error);
                setLoader(false);
            }
        );
    };

    return (
        <div className="nosidebar-page__main">
            <div className="dashboard" style={{ minHeight: '100vh' }}>
                <div className='container p-4'>
                    <div className="card case-study-detail shadow p-4">
                        <h5 className="text-muted d-flex justify-content-start align-items-center">   <img
                            src="/images/calendar_month.svg"
                            alt="calendar icon"
                            style={{ width: "20px", height: "18px", marginRight: "6px" }}
                        /> {CaseStudieDetails[0]?.year}</h5>
                        <h2 className="fw-bold mb-3">{CaseStudieDetails[0]?.title}</h2>
                        <div className='d-flex justify-content-start align-items-center mb-4'>
                            {CaseStudieDetails[0]?.tags?.map((tag, index) => {
                                let tagClass = 'case-tag mb-2 me-2 ';
                                if (tag === 'Employer Responsibility') tagClass += 'employer';
                                else if (tag === 'IC Constitution') tagClass += 'ic';
                                else if (tag === 'Govt Organisation') tagClass += 'govt';
                                else tagClass += 'bg-light text-dark';

                                return (
                                    <span key={index} className={tagClass}>{tag}</span>
                                );
                            })}
                        </div>
                        {loader ? <Loader /> : <div className='case-study-content' dangerouslySetInnerHTML={{ __html: CaseStudieDetails[0]?.case_study }} />}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CaseStudieDetail;